// src/components/ui/CartIcon.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../../contexts/CartContext';
import casierIcon from '../../assets/icone_bdc_64.png'; // ✨ PNG optimisé (1.3 Ko)
import '../../styles/cart-icon.css';

const CartIcon = ({ size = 'medium', showBadge = true, className = '' }) => {
  const navigate = useNavigate();
  const { getTotalItems } = React.useContext(CartContext);
  
  const totalItems = getTotalItems();
  
  // Tailles d'icône
  const sizes = {
    small: 32,
    medium: 40,
    large: 48
  };
  
  const iconSize = sizes[size] || sizes.medium;
  
  const handleClick = () => {
    navigate('/cart');
  };
  
  return (
    <button 
      className={`cart-icon-button ${className}`}
      onClick={handleClick}
      aria-label={`Panier - ${totalItems} article${totalItems > 1 ? 's' : ''}`}
    >
      {/* Icône casier PNG optimisé */}
      <img 
        src={casierIcon} 
        alt="Panier" 
        className="cart-icon-image"
        style={{ width: iconSize, height: iconSize }}
      />
      
      {/* Badge avec le nombre d'articles */}
      {showBadge && totalItems > 0 && (
        <span className="cart-icon-badge">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
    </button>
  );
};

export default CartIcon;